export const CASE_STUDY_SHOTS = {
  platemind: {
    title: "See PlateMind in action",
    groups: [
      {
        title: null,
        items: [
          { src: "/assets/shots/platemind-1.png", caption: "The everyday dashboard: check-ins, plan usage and glucose at a glance" },
          { src: "/assets/shots/platemind-2.png", caption: "Meal analysis with portion guidance and carbohydrate estimates" },
          { src: "/assets/shots/platemind-3.png", caption: "Lana, the virtual dietitian, guiding a real meal decision" },
        ],
      },
    ],
  },
  onconourish: {
    title: "See OncoNourish in action",
    groups: [
      {
        title: null,
        items: [
          { src: "/assets/shots/onconourish-1.png", caption: "A gentle intake conversation, in the patient's own words" },
          { src: "/assets/shots/onconourish-2.png", caption: "Symptom-aware questions that shape each person's plan" },
          { src: "/assets/shots/onconourish-3.png", caption: "Optional caregiver and family involvement" },
        ],
      },
    ],
  },
  "sito-health": {
    title: "See Sito Health in action",
    groups: [
      {
        title: null,
        items: [
          { src: "/assets/shots/sito-1.png", caption: "Specialist care across metabolic health" },
          { src: "/assets/shots/sito-2.png", caption: "Simple consultation booking" },
          { src: "/assets/shots/sito-3.png", caption: "Plain-language answers to common questions" },
        ],
      },
    ],
  },
  "lana-clinical": {
    title: "See Lana Clinical in action",
    groups: [
      {
        title: "Physician view",
        items: [
          { src: "/assets/shots/lana-p1.png", caption: "Clinician dashboard with the caseload at a glance" },
          { src: "/assets/shots/lana-p2.png", caption: "Patients organised by priority and nutrition risk" },
          { src: "/assets/shots/lana-p3.png", caption: "Patient view with symptom timeline and Decision Twin" },
        ],
      },
      {
        title: "Client view",
        items: [
          { src: "/assets/shots/lana-c1.png", caption: "Client home with daily tasks and reminders" },
          { src: "/assets/shots/lana-c2.png", caption: "A short daily check-in keeps the care team close" },
          { src: "/assets/shots/lana-c3.png", caption: "Learning centre with practical treatment guides" },
        ],
      },
    ],
  },
};
